'use client'
// Code modified from https://github.com/Nutlope/intercom-nextjs
import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { useUser } from '@auth0/nextjs-auth0/client'

// APP ID can only be used on our domain
// https://www.intercom.com/help/en/articles/4418-list-trusted-domains-you-use-with-your-messenger
const APP_ID = 'gcyvfmuh'

// Loads Intercom with the snippet
// This must be run before boot, it initializes window.Intercom
const loadIntercom = () => {
  // prettier-ignore
  (function () {
    var w = window
    var ic = w.Intercom
    if (typeof ic === 'function') {
      ic('reattach_activator')
      ic('update', w.intercomSettings)
    } else {
      var d = document
      var i = function () {
        i.c(arguments)
      }
      i.q = []
      i.c = function (args) {
        i.q.push(args)
      }
      w.Intercom = i
      var l = function () {
        var s = d.createElement('script')
        s.type = 'text/javascript'
        s.async = true
        s.src = 'https://widget.intercom.io/widget/' + APP_ID
        var x = d.getElementsByTagName('script')[0]
        x.parentNode.insertBefore(s, x)
      }
      if (document.readyState === 'complete') {
        l()
      } else if (w.attachEvent) {
        w.attachEvent('onload', l)
      } else {
        w.addEventListener('load', l, false)
      }
    }
  })()
}

// Initializes Intercom
const bootIntercom = (options = {}) => {
  window &&
    window.Intercom &&
    window.Intercom('boot', {
      app_id: APP_ID,
      custom_launcher_selector: '#get-in-touch',
      ...options,
    })
}

const updateIntercom = () => {
  window && window.Intercom && window.Intercom('update')
}

export const IntercomProvider = ({ children, isApp }) => {
  const pathname = usePathname()
  if (isApp) {
    const { user, isLoading } = useUser()
    if (typeof window !== 'undefined' && !isLoading) {
      loadIntercom()
      bootIntercom({
        name: user.name, // will be email for username/password users
        email: user.email,
        user_id: user.sub,
        org_id: user.org_id,
        hide_default_launcher: true,
      })
    }
  } else {
    if (typeof window !== 'undefined') {
      loadIntercom()
      bootIntercom()
    }
  }

  // Update Intercom when pathname changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      updateIntercom()
    }
  }, [pathname])

  return children
}
